var _SelectEnumerator_enumerator, _SelectEnumerator_selector, _SelectEnumerator_currentItem;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import EnumeratorBase from "./EnumeratorBase";
import Exception from '../Exceptions/Exception';
export default class SelectEnumerator extends EnumeratorBase {
    constructor(enumerator, selector) {
        super();
        _SelectEnumerator_enumerator.set(this, void 0);
        _SelectEnumerator_selector.set(this, void 0);
        _SelectEnumerator_currentItem.set(this, void 0);
        __classPrivateFieldSet(this, _SelectEnumerator_enumerator, enumerator, "f");
        __classPrivateFieldSet(this, _SelectEnumerator_selector, selector, "f");
    }
    get current() {
        if (__classPrivateFieldGet(this, _SelectEnumerator_currentItem, "f") === undefined) {
            throw new Exception("Current is undefined");
        }
        return __classPrivateFieldGet(this, _SelectEnumerator_currentItem, "f");
    }
    moveNext() {
        __classPrivateFieldSet(this, _SelectEnumerator_currentItem, this.peek(), "f");
        if (__classPrivateFieldGet(this, _SelectEnumerator_currentItem, "f") === undefined) {
            return false;
        }
        return __classPrivateFieldGet(this, _SelectEnumerator_enumerator, "f").moveNext();
    }
    peek() {
        const item = __classPrivateFieldGet(this, _SelectEnumerator_enumerator, "f").peek();
        if (item === undefined) {
            return;
        }
        return __classPrivateFieldGet(this, _SelectEnumerator_selector, "f").call(this, item);
    }
    reset() {
        __classPrivateFieldGet(this, _SelectEnumerator_enumerator, "f").reset();
    }
}
_SelectEnumerator_enumerator = new WeakMap(), _SelectEnumerator_selector = new WeakMap(), _SelectEnumerator_currentItem = new WeakMap();
